'use client';

import { FormButton } from '@monoimin/atoms';

type ResetDueErrorProps = {
  reset: () => void;
};

export function ResetDueError({ reset }: ResetDueErrorProps) {
  return (
    <section data-testid='reset-due-error'>
      <div className='container flex flex-col items-center justify-center gap-6 min-h-screen'>
        <h2 className='h2'>Something went wrong!</h2>
        <FormButton className='h3' variant='secondary' onClick={reset}>
          Try again
        </FormButton>
      </div>
    </section>
  );
}
